/**
 * Cookie carrying the active admin impersonation session — base64url JSON
 * `{ token, shop }`. Deliberately NOT httpOnly: the standalone client reads it
 * to seed the App Bridge stub, and `_document` reads it server-side to suppress
 * the App-Bridge CDN redirect. Shared by server (set/clear) and client (read).
 *
 * Kept dependency-free (no node builtins) so the client bundle can import the
 * name without pulling in `crypto` from `session-token.util`.
 */
export const IMPERSONATION_COOKIE = 'tb_impersonation';
